<div class="bottom-bar shadow-sm">
  <div class="container-fluid">
    <div class="row align-items-center justify-content-between py-2 py-sm-3 sticky-top">

      <!-- LOGO -->
      <div class="col-auto col-md-2">
        <div class="logo float-start">
          <a [routerLink]="['/']">
            <img src="assets/images/logo.jpg" alt="Logo" />
          </a>
        </div>
      </div>

      <!-- ================= MARKETPLACE LAYOUT ================= -->
      <ng-container *ngIf="isMarketplacePage; else defaultNav">

        <!-- Desktop nav links (lg and up) -->
        <div class="col-auto d-none d-lg-block order-2 order-lg-1">
          <nav class="nav navbar navbar-expand-md p-0">
            <div class="navbar-nav flex-row marketplace-nav-links">
               <a [routerLink]="['/marketplace']"
                  [class.active]="isMarketplacePage"
                  [class.nav-active-border]="isMarketplacePage"
                  class="nav-item nav-link">{{ "common.marketplace" | translate }}</a>

              <div class="nav-item" ngbDropdown>
                <a class="nav-link dropdown-toggle" ngbDropdownToggle>{{ "menu.place_command" | translate }}</a>
                <div ngbDropdownMenu>
                  <a class="dropdown-item" [routerLink]="['/user','place-your-command']">{{ "menu.place_command" | translate }}</a>
                   <a class="dropdown-item" [routerLink]="['/market-bag']">Market bag</a>
                </div>
              </div>
            </div>
          </nav>
        </div>

        <!-- Desktop search bar (lg and up) -->
        <div class="col d-none d-lg-block order-lg-2">
          <form class="marketplace-search" [formGroup]="searchForm">
            <i class="fa fa-search search-icon"></i>
            <input
              type="text"
              formControlName="q"
              class="form-control"
              placeholder="{{ 'common.search_placeholder' | translate }}"
              (keydown.enter)="search()"
            />
            <button type="button" (click)="search()" aria-label="Search">
              <i class="fa fa-search"></i>
            </button>
          </form>
        </div>

        <!-- Mobile icons: search toggle + cart + hamburger (below lg) -->
        <div class="col d-flex d-lg-none justify-content-end align-items-center order-2 marketplace-mobile-icons">
          <button type="button" class="btn mobile-search-toggle" (click)="toggleMobileSearch()" aria-label="Toggle search">
            <i class="fa fa-search fa-md"></i>
          </button>
          <a href="#" class="btn cart d-flex position-relative" [routerLink]="['/shopping-cart']">
            <i class="fa fa-shopping-cart fa-md"></i>
            <span class="badge badge-warning" id="lblCartCountMobile">{{ nbOfProducts(products | async) }}</span>
          </a>
          <a class="btn border-0" id="menu-btn" data-trigger="navbar_main">
            <i class="fa fa-bars fa-md"></i>
          </a>
        </div>

        <!-- Mobile collapsible search row (below lg) -->
        <div class="col-12 order-3 d-lg-none mobile-marketplace-search-wrap"
             [class.mp-search-expanded]="mobileSearchOpen">
          <form class="marketplace-search" [formGroup]="searchForm">
            <i class="fa fa-search search-icon"></i>
            <input
              type="text"
              formControlName="q"
              class="form-control"
              placeholder="{{ 'common.search_placeholder' | translate }}"
              (keydown.enter)="search()"
            />
            <button type="button" (click)="search()" aria-label="Search">
              <i class="fa fa-search"></i>
            </button>
          </form>
        </div>

        <!-- Marketplace mobile offcanvas menu (reuses navbar_main id/trigger) -->
        <nav id="navbar_main" class="mobile-offcanvas navbar navbar-dark d-lg-none">
          <div class="container-fluid">
            <div class="offcanvas-header">
              <button class="btn-close float-end"></button>
            </div>
            <div class="py-3 border-bottom border-primary">
              <h4 class="text-center">Menu</h4>
            </div>
            <ul class="navbar-nav flex-column mt-3">
              <li class="nav-item">
                <a class="nav-link" [routerLink]="['/']"
                   routerLinkActive="active nav-active-border"
                   [routerLinkActiveOptions]="{ exact: true }">{{ "common.home" | translate }}</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [routerLink]="['/marketplace']"
                   [class.active]="isMarketplacePage"
                   [class.nav-active-border]="isMarketplacePage">{{ "common.marketplace" | translate }}</a>
              </li>
              <li class="nav-item" ngbDropdown>
                 <a class="nav-link dropdown-toggle" ngbDropdownToggle>{{ "menu.place_command" | translate }}</a>
                 <div ngbDropdownMenu>
                   <a class="dropdown-item" [routerLink]="['/user','place-your-command']">{{ "menu.place_command" | translate }}</a>
                  <a class="dropdown-item" [routerLink]="['/market-bag']">Market bag</a>
                 </div>
              </li>
            </ul>
          </div>
        </nav>

        <!-- Desktop wishlist + cart (lg and up only) -->
        <div class="col-lg-2 d-none d-lg-block order-lg-3">
          <div class="user d-flex align-items-center justify-content-end">
            <a *ngIf="user" [routerLink]="['/user', user.id, 'wishlist']" class="btn wishlist d-flex">
              <i class="far fa-heart"></i>
              <span>({{ wishlistCount }})</span>
            </a>
            <a href="#" class="btn cart d-flex position-relative" [routerLink]="['/shopping-cart']">
              <i class="fa fa-shopping-cart"></i>
              <span class="badge badge-warning" id="lblCartCount">{{ nbOfProducts(products | async) }}</span>
            </a>
          </div>
        </div>
      </ng-container>

      <!-- ================= DEFAULT LAYOUT (unchanged) ================= -->
      <ng-template #defaultNav>
        <div class="col-sm-4 col-md-6 col-lg-4 d-sm-none d-md-block d-lg-none d-none">
          <nav class="navbar navbar-expand-md">
            <div class="justify-content-between" id="navbarCollapse">
              <div class="navbar-nav me-2 flex-row">
                 <a [routerLink]="['/']" [title]="'common.home' | translate" routerLinkActive="active nav-active-border" [routerLinkActiveOptions]="{ exact: true }" class="nav-item nav-link">{{
                   "common.home" | translate }}</a>
                   <a [routerLink]="['/marketplace']" routerLinkActive="active nav-active-border" class="nav-item nav-link">{{
                     "common.marketplace" | translate
                     }}</a>
                 <a [routerLink]="['/market-prices']" routerLinkActive="active nav-active-border" class="nav-item nav-link">{{ "common.market_prices" | translate }}</a>
                 <a [routerLink]="['/blog']" routerLinkActive="active nav-active-border" class="nav-item nav-link">Blog</a>
                   <a [routerLink]="['/contact-us']" routerLinkActive="active nav-active-border" class="nav-item nav-link">{{
                     "menu.contact" | translate
                     }}</a>
              </div>
            </div>
          </nav>
        </div>
        <div class="col-lg-8 col-md-5 col-sm-5 col-6">
          <div class="offcanvas-header d-lg-none d-flex align-items-center justify-content-end">
            <div>
              <a class="btn border-0 text-primary position-relative" [routerLink]="['/shopping-cart']">
                <i class="fa fa-shopping-cart fa-md"></i>
                <span class="badge badge-warning" id="lblCartCount">
                  {{ nbOfProducts(products | async) }}
                </span>
              </a>
            </div>
            <div class="float-end">
              <a class="btn border-0" id="menu-btn" data-trigger="navbar_main">
                <i class="fa fa-bars fa-md"></i>
              </a>
            </div>
          </div>

          <nav id="navbar_main"
            class="mobile-offcanvas navbar navbar-expand-md navbar-dark bg-lg-none float-lg-none float-end">
            <div class="container-fluid d-lg-none">
              <div class="offcanvas-header">
                <button class="btn-close float-end"></button>
              </div>
              <div class="py-3 border-bottom border-primary">
                <h4 class="text-center">Profile</h4>
              </div>

              <ul class="navbar-nav flex-column mt-3">
                <li class="nav-item active">
                  <a *ngIf="!userService.isLoggedIn(); else logout" [routerLink]="['/signin']" class="nav-link">
                    {{ "rightnav.log_in" | translate }}
                  </a>
                  <ng-template #logout>
                    <a (click)="userService.logout()" class="nav-link">
                      {{ "rightnav.sign_out" | translate }}
                    </a>
                  </ng-template>
                </li>
                <li class="nav-item">
                  <a class="nav-link" [routerLink]="['/user','dashboard']">
                    {{ "rightnav.my_account" | translate }}
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" [routerLink]="['/']" routerLinkActive="active nav-active-border" [routerLinkActiveOptions]="{ exact: true }">{{
                    "common.home" | translate
                    }}</a>
                </li>
                <li class="nav-item">
                   <a class="nav-link" [routerLink]="['/marketplace']" routerLinkActive="active nav-active-border">
                     {{ "common.marketplace" | translate }}
                  </a>
                </li>
                 <a [routerLink]="['/market-prices']" routerLinkActive="active nav-active-border" class="nav-item nav-link">{{ "common.market_prices" | translate }}</a>
                 <a [routerLink]="['/blog']" routerLinkActive="active nav-active-border" class="nav-item nav-link">Blog</a>
                 <li class="nav-item">
                   <a class="nav-link" [routerLink]="['/contact-us']" routerLinkActive="active nav-active-border">
                     {{ "menu.contact" | translate }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="justify-content-around d-lg-block d-none w-100" id="navbarCollapse">
              <div class="navbar-nav w-100 d-flex justify-content-around">
                <a [routerLink]="['/']" [title]="'common.home' | translate" routerLinkActive="active nav-active-border" [routerLinkActiveOptions]="{ exact: true }" class="nav-item nav-link">{{
                  "common.home" | translate }}</a>
                 <a [routerLink]="['/marketplace']" routerLinkActive="active nav-active-border" class="nav-item nav-link">{{
                   "common.marketplace" | translate
                   }}</a>
                 <a [routerLink]="['/market-prices']" routerLinkActive="active nav-active-border" class="nav-item nav-link">{{ "common.market_prices" | translate }}</a>
                 <a [routerLink]="['/blog']" routerLinkActive="active nav-active-border" class="nav-item nav-link">Blog</a>
                 <a [routerLink]="['/contact-us']" routerLinkActive="active nav-active-border" class="nav-item nav-link">{{
                  "menu.contact" | translate
                  }}</a>
              </div>
            </div>
          </nav>
        </div>

        <div class="col-md-2 d-none d-lg-block">
          <div class="user d-flex align-items-center">
            <a *ngIf="user" [routerLink]="['/user', user.id, 'wishlist']" class="btn wishlist d-flex">
              <i class="far fa-heart"></i>
              <span>({{ wishlistCount }})</span>
            </a>
            <a href="#" class="btn cart d-flex position-relative" [routerLink]="['/shopping-cart']">
              <i class="fa fa-shopping-cart"></i>
              <span class="badge badge-warning" id="lblCartCount">{{
                nbOfProducts(products | async)
                }}</span>
            </a>
          </div>
        </div>
      </ng-template>

    </div>
  </div>
</div>